import httpService, { HttpResponse } from '../../../core/services/HttpService';

export interface EffectiveRate {
  id: number;
  employee: number;
  valid_from: string; // ISO date (YYYY-MM-DD)
  hourly_rate: number; // in EUR
  currency?: string; // 'EUR'
}

export interface UpsertRatePayload {
  employee: number;
  valid_from: string; // YYYY-MM-DD
  hourly_rate: number;
  currency?: string;
}

class EarningsRateService {
  static async listRates(params?: { employee?: number }): Promise<EffectiveRate[]> {
    const response: HttpResponse<EffectiveRate[]> = await httpService.get('/api/earnings/effective-rates/', { params });
    return response.data || [];
  }

  static async upsertRate(payload: UpsertRatePayload): Promise<EffectiveRate> {
    const response = await httpService.post<EffectiveRate>('/api/earnings/effective-rates/upsert/', payload);
    return response.data;
  }

  static async deleteRate(id: number): Promise<void> {
    await httpService.delete(`/api/earnings/effective-rates/${id}/`);
  }
}

export default EarningsRateService;


